import {DropzoneOrFiles} from './components';

export default DropzoneOrFiles;
